import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e46f13ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-center items-center h-full" }
const _hoisted_2 = { class: "w-1/3 flex flex-col gap-4" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "flex gap-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "w-full" }
const _hoisted_14 = { class: "inputTitle" }
const _hoisted_15 = { class: "inputField flex-grow" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "w-full flex flex-row items-center gap-2" }
const _hoisted_19 = { class: "w-[200px]" }
const _hoisted_20 = { class: "w-full flex justify-center items-center pseudoButton pseudoPrimary" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "flex gap-2" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = { key: 3 }

import {computed, onMounted, ref} from "vue";
import {useGuestStore} from "@/stores/GuestStore";
import {ErrorLocationType, TicketType, ValidationStateType} from "@/utilities/enums/Enums";
import TextOrSpinner from "@/components/TextOrSpinner.vue";
import router from "@/router";
import {useI18n} from "vue-i18n";
import Error from "@/components/Error.vue";
import CustomUploadProcessIndicator from "@/components/CustomUploadProcessIndicator.vue";
import GuestService from "@/utilities/services/GuestService";
import {useUploadSessionStore} from "@/stores/UploadSessionStore";
import OldProjectFile from "@/models/entities/old/ProjectFile";
import {IndexedDbService} from "@/utilities/services/IndexedDbService";
import {UploadSession} from "@/models/helpers/UploadSession";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {useGlobalStore} from "@/stores/GlobalStore";
import {TicketFileInfoResponse} from "@/models/entities/ModelHelpers";
import {formatBytes} from "@/utilities/helpers/ByteStringHelper";
import {convertOldProjectFileToNew} from "@/utilities/helpers/Converters";



export default /*#__PURE__*/_defineComponent({
  __name: 'GuestTicketAction',
  setup(__props) {

const {t} = useI18n();
const guestStore = useGuestStore();
const uploadSessionStore = useUploadSessionStore();
const guestService = new GuestService();
const dbService = new IndexedDbService("uploadGuid");

const actingOnFileAction = ref<boolean>(false);
const messageToCreator = ref<string|null>(null);
const uploadInput = ref<HTMLInputElement|null>(null);
const existingSession = ref<UploadSession|null|undefined>(null);
const ticketFileInfo = ref<TicketFileInfoResponse|null>(null);
const validationState = computed(() => {
  const currentState = uploadSessionStore.validationState;
  if(currentState === ValidationStateType.invalid){
    ErrorHandler.showLocalError(t('general.error.hashing'), ErrorLocationType.guest);
  }
  return currentState
});
const knownFileName = computed(()=> {
  return existingSession.value?.fileName
})

const uploadFileToBrowser = async () => {
  const uploadedFile = uploadInput.value?.files ? uploadInput.value?.files[0] as File : null;
  if (!uploadedFile) return;

  uploadSessionStore.fileToUpload = uploadedFile;
}

const generateTemporaryProjectFile = ():OldProjectFile => {
  const result = new OldProjectFile();
  const file = uploadSessionStore.fileToUpload!

  result.name = file.name;
  result.size = file.size;
  result.type = NullOrUndefinedHelper(file.type) ? "application/octet-stream" : file.type;
  result.desc = "UPLOADED FROM TICKET"
  result.file = file;
  result.urlGuid = NullOrUndefinedHelper(existingSession.value)
      ? ""
      : existingSession.value?.uploadGuid as string;
  result.messageToCreator = messageToCreator.value;

  return result;
}

const startUploadingBlocks = async ()=>{
  if(actingOnFileAction.value) return;
  actingOnFileAction.value = true;

  let tmpProjectFile = generateTemporaryProjectFile();

  const isNewFile = NullOrUndefinedHelper(existingSession.value);
  if(isNewFile) {
    const resp = await guestService.initializeFile(tmpProjectFile, guestStore.ticketGuid, ErrorLocationType.guest);
    if (!resp) {
      actingOnFileAction.value = false;
      return;
    }

    // ensure critical properties surviving the update from the backend
    const type = tmpProjectFile.type;
    const file = tmpProjectFile.file as File;
    tmpProjectFile = resp
    tmpProjectFile.type = type;
    tmpProjectFile.file = file;

    const sessionCreated = await uploadSessionStore.generateUploadSession(convertOldProjectFileToNew(tmpProjectFile), guestStore.ticketGuid, ErrorLocationType.guest);
    if (!sessionCreated) {
      actingOnFileAction.value = false;
      return;
    }

    existingSession.value = await dbService.getItem<UploadSession>(tmpProjectFile.urlGuid, ErrorLocationType.guest);
  }

  const missingBlocksSend = await uploadSessionStore.uploadMissingBlocks(tmpProjectFile.urlGuid, isNewFile, ErrorLocationType.guest);
  if(!missingBlocksSend) {
    actingOnFileAction.value = false;
    return;
  }

  const sessionClosed = await uploadSessionStore.closeSession(tmpProjectFile.urlGuid, ErrorLocationType.guest);
  if(!sessionClosed) {
    actingOnFileAction.value = false;
    return;
  }

  guestStore.showSuccess(t('general.uploaded'));

  actingOnFileAction.value = false;
}

const downloadFile = async ()=>{
  actingOnFileAction.value = true;
  const resp = await guestService.downloadFile(guestStore.ticketGuid as string, updateDownloadProgress, ErrorLocationType.guest, guestStore.ticketType === TicketType.staticDownload)
  if(!resp) return;
  actingOnFileAction.value = false;
}

const updateDownloadProgress = async (newProgress:string) => {
  const globalStore = useGlobalStore();
  globalStore.success.progressPercentage = newProgress;
}

onMounted(async () => {
  if(!guestStore.token) await router.push("/logout");

  const resp = await guestService.getTicketFileInfo(guestStore.ticketGuid!, ErrorLocationType.guest, guestStore.ticketType === TicketType.staticDownload);
  if(resp) {
    ticketFileInfo.value = resp;
  }

  const sessions = await dbService.listItems<UploadSession>(ErrorLocationType.guest)
  existingSession.value = guestStore.ticketType === TicketType.upload && sessions?.some(()=>true)
      ? sessions?.find(us => us.ticketGuid == guestStore.ticketGuid)
      : null;

  uploadSessionStore.totalPercentage = existingSession.value !== null
      ? await uploadSessionStore.getTotalUploadPercentage(existingSession.value!.uploadGuid, ErrorLocationType.guest) ?? "0%"
      : "0%";
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Error, {
        errorLoc: _unref(ErrorLocationType).guest
      }, null, 8, ["errorLoc"]),
      (_unref(guestStore).ticketType === _unref(TicketType).download)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(_unref(t)('external.action.fileName')) + ":", 1),
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_unref(t)('external.action.fileSize')) + ":", 1),
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_unref(t)('external.action.creator')) + ":", 1),
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_unref(t)('external.action.messageToRecipient')) + ": ", 1)
              ]),
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(ticketFileInfo.value.fileName), 1),
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(_unref(formatBytes)(ticketFileInfo.value.fileSize)), 1),
                _hoisted_9,
                _createTextVNode(" " + _toDisplayString(ticketFileInfo.value.creatorName), 1),
                _hoisted_10,
                _createTextVNode(" " + _toDisplayString(ticketFileInfo.value.messageToRecipient), 1)
              ])
            ]),
            _hoisted_11,
            _createElementVNode("button", {
              class: "btn primary",
              onClick: downloadFile
            }, [
              _createVNode(TextOrSpinner, {
                text: _unref(t)('external.downloadFile'),
                spin: actingOnFileAction.value
              }, null, 8, ["text", "spin"])
            ])
          ]))
        : (_unref(guestStore).ticketType === _unref(TicketType).upload)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('external.action.messageToCreator')), 1),
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((messageToCreator).value = $event)),
                      class: "w-full min-h-[80px]",
                      placeholder: _unref(t)('external.action.help.messageToCreator')
                    }, null, 8, _hoisted_16), [
                      [_vModelText, messageToCreator.value]
                    ]),
                    _hoisted_17
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("label", _hoisted_19, [
                  _createElementVNode("input", {
                    type: "file",
                    accept: "*/*",
                    multiple: false,
                    ref_key: "uploadInput",
                    ref: uploadInput,
                    onChange: uploadFileToBrowser,
                    style: {"display":"none"}
                  }, null, 544),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('external.selectFile')), 1)
                ]),
                _createVNode(CustomUploadProcessIndicator, {
                  class: "flex-grow",
                  percentage: _unref(uploadSessionStore).totalPercentage,
                  validationState: validationState.value,
                  knownFileName: knownFileName.value,
                  uploadFileName: _unref(uploadSessionStore).fileToUpload?.name,
                  fileSize: _unref(uploadSessionStore).fileToUpload?.size
                }, null, 8, ["percentage", "validationState", "knownFileName", "uploadFileName", "fileSize"])
              ]),
              _createElementVNode("button", {
                class: "btn primary mt-7 w-full",
                onClick: startUploadingBlocks,
                disabled: _unref(uploadSessionStore).fileToUpload === null
              }, [
                _createVNode(TextOrSpinner, {
                  text: _unref(t)('external.uploadFile'),
                  spin: actingOnFileAction.value,
                  disabled: !actingOnFileAction.value
                }, null, 8, ["text", "spin", "disabled"])
              ], 8, _hoisted_21)
            ]))
          : (_unref(guestStore).ticketType === _unref(TicketType).staticDownload)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_unref(t)('external.action.fileName')) + ":", 1),
                    _hoisted_24,
                    _createTextVNode(" " + _toDisplayString(_unref(t)('external.action.fileSize')) + ":", 1),
                    _hoisted_25,
                    _createTextVNode(" " + _toDisplayString(_unref(t)('external.action.creator')) + ":", 1),
                    _hoisted_26,
                    _createTextVNode(" " + _toDisplayString(_unref(t)('external.action.messageToRecipient')) + ": ", 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(ticketFileInfo.value.fileName), 1),
                    _hoisted_27,
                    _createTextVNode(" " + _toDisplayString(_unref(formatBytes)(ticketFileInfo.value.fileSize)), 1),
                    _hoisted_28,
                    _createTextVNode(" " + _toDisplayString(ticketFileInfo.value.creatorName), 1),
                    _hoisted_29,
                    _createTextVNode(" " + _toDisplayString(ticketFileInfo.value.messageToRecipient), 1)
                  ])
                ]),
                _hoisted_30,
                _createElementVNode("button", {
                  class: "btn primary",
                  onClick: downloadFile
                }, [
                  _createVNode(TextOrSpinner, {
                    text: _unref(t)('external.auth.startDownload'),
                    spin: actingOnFileAction.value
                  }, null, 8, ["text", "spin"])
                ])
              ]))
            : (_unref(guestStore).ticketType === null || _unref(guestStore).ticketType !== _unref(TicketType).upload || _unref(guestStore).ticketType !== _unref(TicketType).download)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_unref(t)('external.invalidTicketType')), 1))
              : _createCommentVNode("", true)
    ])
  ]))
}
}

})